export async function pollRequest<T>(
  requestFn: () => Promise<T | null | undefined>,
  tries: number,
  delayMs = 500,
): Promise<T | null> {
  for (let attempt = 0; attempt < Math.max(0, tries); attempt++) {
    try {
      const result = await requestFn();
      if (result) {
        return result;
      }
    } catch (_) {
      // swallow and retry
    }
    if (attempt < tries - 1) {
      await new Promise(resolve => setTimeout(resolve, delayMs));
    }
  }
  return null;
}
